(function () {
    angular.module('relatedContentResource', ['ngResource'])
        .factory('relatedContentResource', relatedContentResource);

    relatedContentResource.$inject = ['$resource'];
    function relatedContentResource($resource) {
        return {
            list: $resource('/api/related-content/')
        };
    }
})();